import { DateTransform } from '@app/shared/utils/date.transform';

export class DateRangeApiModel {
  public ProgramRoleId: string;
  public StartDate: Date;
  public EndDate: Date;

  public deserialize(data: Object): DateRangeApiModel {
    Object.assign(this, data);

    this.StartDate = DateTransform.shortUTCDate(this.StartDate);
    this.EndDate = DateTransform.shortUTCDate(this.EndDate);

    return this;
  }
}
